<template>
  <UserLayout :searchType="'trainers'">
    <div
      class="ring-1 ring-gray-300 w-full rounded-lg"
      :class="LOADING ? 'bg-gray-medium' : 'bg-blue-lightest'"
    >
      <div class="md:hidden relative">
        <div :class="LOADING ? 'h-64' : 'h-64'">
          <img
            :src="require('@/assets/img/trainer-list-banner.jpg')"
            alt=""
            class="shadow ring-1 ring-gray-300 object-cover w-full rounded-lg h-64"
            @load="imgLoadHandler"
            v-show="!LOADING"
            @error="defaultBannerImage"
          />
        </div>
        <div
          class="flex items-center absolute top-0 right-0 bg-black bg-opacity-50 h-full rounded-lg"
        >
          <div class="md:px-32 px-16 space-y-4 md:space-x-2">
            <h3
              class="md:text-5xl text-xl leading-none capitalize font-semibold text-white pr-6"
            >
              Find <br />
              Trainers
            </h3>
            <p class="md:text-lg text-sm text-white">
              Let's start the climb to the next step <br />
              Find a trainer now!
            </p>
          </div>
        </div>
      </div>
      <div class="hidden md:flex">
        <div class="w-6/12 flex items-center">
          <div class="md:px-24 lg:px-32 space-y-4 space-x-2">
            <h3
              class="text-5xl leading-none capitalize font-semibold text-gray-dark"
            >
              Find <br />
              Trainer
            </h3>
            <p class="text-lg">
              Let's start the climb to the next step <br />
              Find a trainer now!
            </p>
          </div>
        </div>
        <div
          class="w-6/12 px-6 md:py-24 lg:py-4"
          :class="LOADING ? 'h-banner' : 'h-banner'"
        >
          <img
            :src="require('@/assets/img/trainer-list-banner.jpg')"
            alt=""
            class="shadow ring-1 ring-gray-300 object-cover w-full rounded-lg h-full"
            @load="imgLoadHandler"
            v-show="!LOADING"
          />
        </div>
      </div>
    </div>

    <div>
      <div class="flex-col flex-1">
        <div class="flex items-center justify-between mt-2">
          <div class="py-1">
            <div class="flex items-center md:py-4">
              <button
                type="button"
                class="whitespace-nowrap inline-flex items-center h-8 px-2 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleClickMenu"
              >
                <p class="text-sm px-1">Filters</p>
                <FilterIcon />
              </button>
              <div v-if="filterChipValues.length" class="flex items-center">
                <span class="text-3xl px-2 text-gray-dark font-leading">|</span>
                <div v-for="el in filterChipValues" :key="el.key" class="mr-2">
                  <FilterChip
                    class="w-max"
                    :data="el"
                    :handleClearFilterValue="handleClearFilterValue"
                  />
                </div>
                <button
                  type="button"
                  class="text-green-dark text-sm w-max px-1 flex rounded-lg"
                  @click="handleResetFilterValues"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="">
          <!-- Category section -->
          <section class="md:mb-20 mb-8"
            v-if="
              !filterChipValues.length &&
              !searchValue &&
              topTrainerList &&
              topTrainerList.data
            "
          >
            <div class="flex justify-between items-center mb-4">
              <h6
                class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
              >
                Top Trainers
              </h6>
              <button
                type="button"
                class="whitespace-nowrap inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('category', topTrainerList)"
                v-if="
                  topTrainerList &&
                  topTrainerList.data &&
                  topTrainerList.data.length > 4
                "
              >
                <span class="px-1">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>

            <TrainerListCarousel
              :trainerListData="topTrainerList && topTrainerList.data"
              :statusCode="topTrainerList && topTrainerList.statusCode"
            />
          </section>

          <!-- Language section -->
          <section class="md:mb-20 mb-8"
            v-if="
              !filterChipValues.length &&
              !searchValue &&
              categoryTrainerList &&
              categoryTrainerList.data
            "
          >
            <div class="flex justify-between items-center mb-4">
              <h6
                class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
              >
                Yoga Category Trainers
              </h6>
              <button
                type="button"
                class="whitespace-nowrap inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('category', categories[0])"
                v-if="
                  categoryTrainerList &&
                  categoryTrainerList.data &&
                  categoryTrainerList.data.length > 4
                "
              >
                <span class="px-1">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>

            <TrainerListCarousel
              :trainerListData="categoryTrainerList && categoryTrainerList.data"
              :statusCode="
                categoryTrainerList && categoryTrainerList.statusCode
              "
            />
          </section>

          <!-- sub banner section -->
          <section v-if="!filterChipValues.length && !searchValue">
            <div class="my-12">
              <img
                src=""
                alt=""
                class="shadow ring-1 ring-gray-300 object-cover md:h-64 h-40 w-full rounded"
                @error="defaultBannerImage"
              />
            </div>
          </section>

          <!-- Private Session section -->
          <section class="md:mb-20 mb-8"
            v-if="
              !filterChipValues.length &&
              !searchValue &&
              languageTrainerList &&
              languageTrainerList.data
            "
          >
            <div class="flex justify-between items-center mb-4">
              <h6
                class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight"
              >
                English Language Trainers
              </h6>
              <button
                type="button"
                class="whitespace-nowrap inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                @click="handleFilterChange('language', languages[0])"
                v-if="
                  languageTrainerList &&
                  languageTrainerList.data &&
                  languageTrainerList.data.length > 4
                "
              >
                <span class="px-1">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </div>

            <TrainerListCarousel
              :trainerListData="languageTrainerList && languageTrainerList.data"
              :statusCode="
                languageTrainerList && languageTrainerList.statusCode
              "
            />
          </section>
        </div>

        <div class="mb-5">
          <div v-if="filterChipValues.length || searchValue">
            <TrainersFindCard
              :trainerListData="trainerListData"
              :statusCode="trainerList && trainerList.statusCode"
            />
            <Pagination
              v-if="trainerListData.length"
              :currentPage="currentPage"
              :handlePageChange="handlePageChange"
              :totalPages="totalPages"
            />
          </div>
          <Modal
            :title="'Filter By'"
            :headerClass="'text-xl pt-1'"
            v-model="isMenuOpen"
            :classStr="'max-w-lg'"
            class="modal"
            :whiteCross="'text-white text-4xl'"
          >
            <!-- <SideBarFilter
              :isMenuOpen="isMenuOpen"
              @allFiltersApplied="setAllFilters"
              :handleFilterChange="handleFilterChange"
              :handleResetFilterValues="handleResetFilterValues"
              :filterListing="[
                {
                  type: 'button',
                  label: 'Category',
                  key: 'category',
                  value: newFilterByValues.category.value,
                  options: [...categories],
                },
                {
                  type: 'button',
                  label: 'Language',
                  value: newFilterByValues.language.value,
                  key: 'language',
                  options: [...languages],
                },
                {
                  type: 'button',
                  label: 'Private Class',
                  value: newFilterByValues.is_private_available.value,
                  key: 'is_private_available',
                  options: [
                    { label: 'Available', value: 1 },
                    { label: 'Not Available', value: 2 },
                  ],
                },
              ]"
            /> -->
            <div class="overflow-scroll" style="height: 72vh">
              <div class="flex justify-between">
                <p class="black mb-2 tracking-wider">Category</p>
              </div>
              <div
                class="grid md:grid-cols-3 grid-cols-2 gap-2 mb-4 p-1 max-w-md"
                :class="showMoreCategory === false ? 'h-24 overflow-hidden': ''"
              >
                <button
                  class="whitespace-nowrap items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedCategories"
                  :key="s.id"
                  @click="onclickCategory(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ s.name }}</span>
                    <X />
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="c in categoriesList"
                  :key="c.id"
                  @click="onclickCategory(c)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ c.name }}</span>
                    <Plus />
                  </div>
                </button>
              </div>
              <button 
                class="underline focus:outline-none italic text-sm pb-2" @click="showMoreCategory = !showMoreCategory">Show {{showMoreCategory?"less":"more"}}
              </button>
              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="text-black mb-2 tracking-wider">Language</p>
              </div>
              <div
                class="grid md:grid-cols-3 grid-cols-2 gap-3 mb-4 p-1 max-w-sm"
              >
                <button
                  class="items-center h-10 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="s in selectedLanguages"
                  :key="s.id"
                  @click="onclickLanguage(s)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ s.language }}</span>
                    <X />
                  </div>
                </button>
                <button
                  class="items-center h-10 text-gray-light transition-colors duration-150 bg-white rounded-lg focus:outline-none ring-1 ring-gray-300 text-sm"
                  v-for="l in languagesList"
                  :key="l.id"
                  @click="onclickLanguage(l)"
                >
                  <div class="flex justify-between px-2">
                    <span class="mr-2">{{ l.language }}</span>
                    <Plus />
                  </div>
                </button>
              </div>
              <hr class="text-gray-400 mb-4" />

              <div class="flex justify-between">
                <p class="black mb-2 tracking-wider">Private Classes</p>
              </div>
              <div class="flex gap-6 px-1">
                <button
                  class="flex flex-col items-center h-24 px-8 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = 1"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == 1,
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.668 8.004v37.333h29.85v-2.666H11.335v-32h36v2.826h2.667V8.004H8.668zm41.334 13.333a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0zm2.666 0a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0z"
                      fill="#364B69"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M40.792 29.11a4 4 0 0 1 2.76-1.106h5.443c1.952 0 3.77.664 5.17 1.987 1.346 1.272 2.047 2.902 2.334 4.448.45 2.429-.016 5.084-1.164 7.437V52.67a3.334 3.334 0 0 1-6.621.548l-.712-4.272-.712 4.272a3.333 3.333 0 0 1-6.622-.548V40.128a4 4 0 0 1-2 .536h-6.802a4 4 0 1 1 0-8h5.2l3.726-3.555v.002zm2.543 15.527v8.034a.666.666 0 0 0 1.324.109l1.39-8.341a1.333 1.333 0 0 1 1.315-1.115h1.275a1.333 1.333 0 0 1 1.315 1.115l1.39 8.34a.666.666 0 0 0 1.324-.108V41.559c0-.214.052-.424.15-.614 1.03-1.986 1.404-4.164 1.06-6.02-.21-1.128-.699-2.197-1.544-2.996-.863-.814-2.007-1.258-3.339-1.258h-5.441c-.343 0-.674.132-.922.368L38.52 34.96c-.247.237-.577.37-.92.37h-5.734a1.333 1.333 0 1 0 0 2.666h6.802c.343 0 .673-.132.92-.37l1.494-1.423a1.333 1.333 0 0 1 2.253.965v7.47-.002z"
                      fill="#364B69"
                    />
                  </svg>

                  <span>Available</span>
                </button>
                <button
                  class="flex flex-col items-center h-24 px-5 text-gray-dark transition-colors duration-150 bg-white rounded-lg ring-1 ring-gray-300 focus:outline-none text-xs"
                  @click="typeSelected = 2"
                  :class="{
                    'bg-green-light text-yellow-100': typeSelected == 2,
                  }"
                >
                  <svg
                    width="50"
                    height="65"
                    viewBox="0 0 65 65"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.668 8.004v37.333h29.85v-2.666H11.335v-32h36v2.826h2.667V8.004H8.668zm41.334 13.333a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0zm2.666 0a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0z"
                      fill="#364B69"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M40.792 29.11a4 4 0 0 1 2.76-1.106h5.443c1.952 0 3.77.664 5.17 1.987 1.346 1.272 2.047 2.902 2.334 4.448.45 2.429-.016 5.084-1.164 7.437V52.67a3.334 3.334 0 0 1-6.621.548l-.712-4.272-.712 4.272a3.333 3.333 0 0 1-6.622-.548V40.128a4 4 0 0 1-2 .536h-6.802a4 4 0 1 1 0-8h5.2l3.726-3.555v.002zm2.543 15.527v8.034a.666.666 0 0 0 1.324.109l1.39-8.341a1.333 1.333 0 0 1 1.315-1.115h1.275a1.333 1.333 0 0 1 1.315 1.115l1.39 8.34a.666.666 0 0 0 1.324-.108V41.559c0-.214.052-.424.15-.614 1.03-1.986 1.404-4.164 1.06-6.02-.21-1.128-.699-2.197-1.544-2.996-.863-.814-2.007-1.258-3.339-1.258h-5.441c-.343 0-.674.132-.922.368L38.52 34.96c-.247.237-.577.37-.92.37h-5.734a1.333 1.333 0 1 0 0 2.666h6.802c.343 0 .673-.132.92-.37l1.494-1.423a1.333 1.333 0 0 1 2.253.965v7.47-.002z"
                      fill="#364B69"
                    />
                  </svg>

                  <span>Not Available</span>
                </button>
              </div> 
            </div> 
            <hr class="text-gray-400 mb-4" />

            <div class="flex items-center justify-between">
              <button
                type="button"
                class="h-10 px-4 text-sm text-gray-dark transition-colors duration-150 rounded-lg focus:outline-none hover:shadow-lg"
                @click="resetAllFilters"
              >
                Clear All
              </button>
              <button
                type="button"
                class="h-10 px-4 text-sm text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:shadow-lg"

                @click="applyAllFilters"
              >
                Apply Filter(s)
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  </UserLayout>
</template>

<script>
import TrainersFindCard from "@/components/TrainersFindCard";
import SideBarFilter from "@/components/SideBarFilter.vue";

import TrainerListCarousel from "@/components/user/TrainerListCarousel.vue";
import { FilterChip, Modal, Pagination } from "@/components/t-components";
import UserLayout from "@/components/layouts/UserLayout";
import { FilterIcon, Plus, X } from "@/components/icons";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrainersList",
  components: {
    Modal,
    UserLayout,
    TrainersFindCard,
    SideBarFilter,
    FilterIcon,
    FilterChip,
    Pagination,
    TrainerListCarousel,
    Plus,
    X,
  },
  data() {
    return {
      isMenuOpen: false,
      languages: [],
      categories: [],
      currentPage: 1,
      totalPages: "",
      trainerListData: [],

      defaultFilterByValues: {
        category: { label: "All", value: "all" },
        is_private_available: { label: "Private Class", value: "all" },

        language: { label: "All", value: "all" },
      },
      newFilterByValues: {
        category: { label: "All", value: "all" },
        is_private_available: { label: "Private Class", value: "all" },

        language: { label: "All", value: "all" },
      },
      filterValues: {},
      filterChipValues: [],
      searchValue: "",
      allFilters: [],
      LOADING: true,
      selectedCategories: [], 
      selectedLanguages: [],
      typeSelected: 1,
      showMoreCategory: false,
    };
  },
  watch: {
    newFilterByValues: function () {
      this.setFilterChipValues();
    },
  },
  computed: {
    ...mapGetters([
      "trainerList",
      "languagesList",
      "categoriesList",
      "filterCategoriesList",
      "topTrainerList",
      "categoryTrainerList",
      "languageTrainerList",
    ]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions([
      "getTrainerList",
      "getFilterCategoriesList",
      "postTopTrainerList",
      "getCategoriesList",
      "getLanguagesList",
      "postCategoryTrainerList",
      "postLanguageTrainerList",
    ]),

    imgLoadHandler() {
      this.LOADING = false;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = { ...this.filterValues, q: this.searchValue };
      this.trainerListData = [];
      await this.getTrainerList({ query, payload });
      this.trainerListData = this.trainerList.data.data || [];
    },

    handleClickMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.showMoreCategory = false;
    },

    // , type
    async handleFilterChange(key, option) {
      let payload = {};
      if (key === "cost") {
        payload = {
          ...this.filterValues,
          ...option.value,
          q: this.searchValue,
        };
      } else if (option.value === "all") {
        payload = {
          ...this.filterValues,
          [key]: "",
          q: this.searchValue,
        };
      } else {
        payload = {
          ...this.filterValues,
          [key]: option.value,
          q: this.searchValue,
        };
      }

      this.trainerListData = [];
      const query = {
        page: 1,
      };
      this.currentPage = 1;
      await this.getTrainerList({ query, payload });
      this.trainerListData = this.trainerList.data.data || [];
      this.totalPages = this.trainerList.data.last_page;

      this.filterValues = { ...this.filterValues, ...payload };
      this.newFilterByValues = { ...this.newFilterByValues, [key]: option };
    },

    async handleResetFilterValues() {
      (this.newFilterByValues = {
        ...this.defaultFilterByValues,
      }),
        (this.filterChipValues = []);

      const query = {
        page: 1,
      };
      const payload = { q: this.searchValue };
      this.currentPage = 1;

      this.trainerListData = [];
      await this.getTrainerList({ query, payload });
      this.filterValues = {};
      this.trainerListData = this.trainerList.data.data || [];
      this.totalPages = this.trainerList.data.last_page;
    },

    async handleClearFilterValue(key, option, type) {
      if (type === "multiple") {
        this.newFilterByValues = {
          ...this.newFilterByValues,
          [key]: {
            ...this.newFilterByValues[key],
            [option]: false,
          },
        };
      } else {
        let payload = {};
        if (key === "cost") {
          payload = {
            ...this.filterValues,
            min: "",
            max: "",
            q: this.searchValue,
          };
        } else {
          payload = { ...this.filterValues, [key]: "", q: this.searchValue };
        }
        const query = {
          page: 1,
        };
        this.currentPage = 1;

        this.trainerListData = [];
        await this.getTrainerList({ query, payload });
        this.trainerListData = this.trainerList.data.data || [];
        this.totalPages = this.trainerList.data.last_page;

        this.filterValues = { ...this.filterValues, ...payload };
        this.newFilterByValues = {
          ...this.newFilterByValues,
          [key]: this.defaultFilterByValues[key],
        };
      }
    },
    setAllFilters(val) {
      this.allFilters = val;
    },

    // applyAllFilters() {
    //   this.handleClickMenu();
    //   this.allFilters.forEach((element) => {
    //     this.handleFilterChange(element.key, element.option, element.type);
    //   });
    // },
    async applyAllFilters(){
      this.searchValue = "search";
      this.handleClickMenu();
      var category = [];
      var language = [];
      const query = { page: 1 };
      this.currentPage = 1;
      this.trainerListData = [];

      this.selectedCategories &&
        this.selectedCategories.forEach((el) => {
          category.push(el.id);
        });

      this.selectedLanguages &&
        this.selectedLanguages.forEach((el) => {
          language.push(el.id);
        });

      const payload = {
        category: category && category.toString(),
        language: language && language.toString(),
        type: this.typeSelected,
      };

      await this.getTrainerList({ query, payload });
      this.trainerListData =
        (this.trainerList &&
          this.trainerList.data &&
          this.trainerList.data.data) ||
        [];
      this.totalPages =
        this.trainerList &&
        this.trainerList.data &&
        this.trainerList.data.last_page;
      
    },
    onclickCategory(cat) {
      var index = this.selectedCategories.findIndex((el) => el.id == cat.id);
      if (index === -1) {
        this.selectedCategories.push(cat);
        this.categoriesList.splice(
          this.categoriesList.findIndex((item) => item.id === cat.id),
          1
        );
      } else {
        this.selectedCategories.splice(
          this.selectedCategories.findIndex((item) => item.id === cat.id),
          1
        );
        this.categoriesList.push(cat);
      }
    },
    onclickLanguage(lang) {
      var index = this.selectedLanguages.findIndex((el) => el.id == lang.id);
      if (index === -1) {
        this.selectedLanguages.push(lang);
        this.languagesList.splice(
          this.languagesList.findIndex((item) => item.id === lang.id),
          1
        );
      } else {
        this.selectedLanguages.splice(
          this.selectedLanguages.findIndex((item) => item.id === lang.id),
          1
        );
        this.languagesList.push(lang);
      }
    },
    resetAllFilters() {
      this.allFilters = [];
      this.handleResetFilterValues();
      (this.typeSelected = 1);
      this.selectedCategories.forEach(element => {
        this.categoriesList.push(element);
      });
      this.selectedCategories.length = 0;

      this.selectedLanguages.forEach(element => {
        this.languagesList.push(element);
      });
      this.selectedLanguages.length = 0;
    },

    setFilterChipValues() {
      const tempArr = [];
      Object.keys(this.newFilterByValues).map((e) => {
        if (this.newFilterByValues[e] != "") {
          if (
            this.newFilterByValues[e].value !=
              this.defaultFilterByValues[e].value &&
            !this.newFilterByValues[e].current_page
          ) {
            tempArr.push({
              key: e,
              option: this.newFilterByValues[e].label,
              type: "single",
            });
          }
          if (
            this.newFilterByValues[e].current_page &&
            this.newFilterByValues[e].value !=
              this.defaultFilterByValues[e].value
          ) {
            tempArr.push({
              key: e,
              option: "Top Trainers",
              value: this.newFilterByValues[e].value,
              type: "single",
            });
          }
        }
      });
      this.filterChipValues = tempArr;
    },
  },
  async created() {
    const query = {
      page: this.currentPage,
    };
    // type,
    const { filter } = this.$route.query;
    if (filter) {
      const payload = {
        q: filter,
      };
      await this.getTrainerList({ query, payload });
      this.searchValue = filter;
    } else {
      await this.getTrainerList({ query });
    }
    this.trainerListData = this.trainerList.data.data || [];
    this.totalPages = this.trainerList.data.last_page;
    await this.getFilterCategoriesList();
    const categories =
      this.filterCategoriesList &&
      this.filterCategoriesList.category.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    this.categories = categories;
    await this.getCategoriesList();
    await this.getLanguagesList();
    const languages = this.languagesList.map((item) => {
      return { label: item.language, value: item.id };
    });
    this.languages = languages;
    if (!filter) {
      await this.postTopTrainerList();
      await this.postCategoryTrainerList({ category: 1 });
      await this.postLanguageTrainerList({ language: 1 });
    }
  },
};
</script>

<style lang="scss" scoped>
.h-banner {
  height: 27rem;
}
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-thumb {
  background: #707070;
  border-radius: 3px;
}
</style>